<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter-title1"><a id="page_v"></a>CONTENTS</p>
<p class="toc"><a href="#/illustrations"><em>List of Illustrations</em></a></p>
<p class="toc"><a href="#/front1"><em>Octave Designation Chart</em></a></p>
<p class="toc"><a href="#/preface01"><em>Preface to the Second Edition</em>    JEFFERY KITE-POWELL</a></p>
<p class="toc"><a href="#/preface02"><em>Preface to the First Edition</em>    STEWART CARTER</a></p>
<p class="tocb"><a href="#/acknowledgments"><em>Acknowledgments</em></a></p>
<p class="toc1"><a href="#/part1"><strong>PART 1.</strong></a></p>
<p class="toc2"><a href="#/part1">VOCAL/CHORAL ISSUES</a></p>
<div class="toc3">
<p class="toc3"><a href="#/chap01">1. National Singing Styles    SALLY SANFORD</a></p>
<p class="toc3"><a href="#/chap02">2. The <em>Bel Canto</em> Singing Style    JULIANNE BAIRD</a></p>
<p class="toc3"><a href="#/chap03">3. Choral Music in France and England    ANNE HARRINGTON HEIDER</a></p>
<p class="toc3b"><span href="#/chap04" title="Link target outside of Sample">4. Choral Music in Italy and the Germanic Lands    GARY TOWNE</span></p>
</div>
<p class="toc1"><span href="#/part2" title="Link target outside of Sample"><strong>PART 2.</strong></span></p>
<p class="toc2"><span href="#/part2" title="Link target outside of Sample">WIND, STRING, AND PERCUSSION INSTRUMENTS</span></p>
<div class="toc3">
<p class="toc3"><span href="#/chap05" title="Link target outside of Sample">5. Woodwinds HERBERT MYERS</span></p>
<p class="toc3"><span href="#/chap06" title="Link target outside of Sample">6. Cornett and Sackbut BRUCE DICKEY</span></p>
<p class="toc3"><span href="#/chap07" title="Link target outside of Sample">7. Trombone STEWART CARTER</span></p>
<p class="toc3"><span href="#/chap08" title="Link target outside of Sample">8. Trumpet and Horn STEVEN E. PLANK</span></p>
<p class="toc3"><span href="#/chap09" title="Link target outside of Sample">9. Percussion Instruments and Their Usage JOHN MICHAEL COOPER</span></p>
<p class="toc3"><span href="#/chap10" title="Link target outside of Sample">10. The Violin: Technique and Style DAVID DOUGLASS</span></p>
<p class="toc3"><span href="#/chap11" title="Link target outside of Sample">11. Historical Approaches to Playing the Violin JULIE ANDRIJESKI</span></p>
<p class="toc3"><span href="#/chap12" title="Link target outside of Sample">12. The Viola da Gamba Family STUART CHENEY WITH BARBARA COEYMAN</span></p>
<p class="toc3"><span href="#/chap13" title="Link target outside of Sample">13. Violoncello and Violone MARC VANSCHEEUWIJCK</span></p>
<p class="toc3"><span href="#/chap14" title="Link target outside of Sample">14. Keyboard Instruments MARK KROLL</span></p>
<p class="toc3b"><span href="#/chap15" title="Link target outside of Sample">15. Plucked String Instruments PAUL O'DETTE</span></p>
</div>
<p class="toc1"><a id="page_vi"></a><span href="#/part3" title="Link target outside of Sample"><strong>PART 3.</strong></span></p>
<p class="toc2"><span href="#/part3" title="Link target outside of Sample">PERFORMANCE PRACTICE AND PRACTICAL CONSIDERATIONS</span></p>
<div class="toc3">
<p class="toc3"><span href="#/chap16" title="Link target outside of Sample">16. Ornamentation in Early Seventeenth-Century Italian Music BRUCE DICKEY</span></p>
<p class="toc3"><span href="#/chap17" title="Link target outside of Sample">17. <em>Basso Continuo</em>  JACK ASHWORTH AND PAUL O'DETTE</span></p>
<p class="toc3"><span href="#/chap18" title="Link target outside of Sample">18. Meter and Tempo GEORGE HOULE</span></p>
<p class="toc3"><span href="#/chap19" title="Link target outside of Sample">19. Tuning and Temperament HERBERT MYERS</span></p>
<p class="toc3b"><span href="#/chap20" title="Link target outside of Sample">20. Pitch and Transposition HERBERT MYERS</span></p>
</div>
<p class="toc1"><span href="#/part4" title="Link target outside of Sample"><strong>PART 4.</strong></span></p>
<p class="toc2"><span href="#/part4" title="Link target outside of Sample">THE SEVENTEENTH-CENTURY STAGE</span></p>
<div class="toc3">
<p class="toc3"><span href="#/chap21" title="Link target outside of Sample">21. Dance DOROTHY OLSSON</span></p>
<p class="toc3b"><span href="#/chap22" title="Link target outside of Sample">22. Teatrical Productions JAMES MIDDLETON</span></p>
</div>
<p class="toc"><span href="#/appendix01" title="Link target outside of Sample">Appendix A. List of Names and Dates</span></p>
<p class="toc"><span href="#/appendix02" title="Link target outside of Sample">Appendix B. <em>A Performer's Guide to Medieval Music:</em> Contents</span></p>
<p class="toc"><span href="#/appendix03" title="Link target outside of Sample">Appendix C. <em>A Performer's Guide to Renaissance Music:</em> Contents</span></p>
<p class="extra-indent"> </p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/contributors" title="Link target outside of Sample"><em>List of Contributors</em></span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3a2af9b2